var currentURL = window.location.href;

if (currentURL.includes("127.0.0.1") || currentURL.includes("192.168.1") || currentURL.includes("localhost")) {
    var backendURL = "http://127.0.0.1:8000";
    var frontendURL = "http://localhost/DHN-DELHI";
}
else {
    var backendURL = "https://www.digitalhealthnews.com";
    var frontendURL = "https://delhi.dhnforum.com";
}

var assetsURL = "https://d33xmv9j3wn8v0.cloudfront.net";
var claimAmount = 0;
var eventPrice = 0;
var backupEventPrice = 0;
var backupEventWithoutGSTPrice = 0;
var eventWithoutGSTPrice = 0;
var eventId = 0;
var discountAmount = "";
var discountName = "";
var discountType = "";
var discountValue = "";
var discountId = "";
var getSponsorshipHome = "";
const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/;
const emailRegex = /(.+)@(.+)\.(.+)/i;
const slider = document.querySelector(".slider");
const slides = document.querySelectorAll(".slide");
let currentIndex = 0;
let interval;

function setFormat(dateString) {
    // Convert to JavaScript Date object
    var date = new Date(dateString);
    // Extract hours and minutes
    var hours = date.getHours();
    var minutes = date.getMinutes();
    // Determine AM/PM
    var ampm = hours >= 12 ? 'PM' : 'AM';
    // Convert hours to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight (0 hours)
    // Format the time string
    var formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + ampm;
    return formattedTime;
}


async function ajaxDynamicMethod(url, method, formData = "", formElement = "") {
    $("#lds-roller").show();
    const response = await $.ajax({
        type: method,
        url: url,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        success: function (data) {
            $(".errors").text("");
            if (data.error) {
                if (data.errors.length == "0" && data.msg) {
                    alert(data.msg);
                } else {
                    for (const [key, value] of Object.entries(data.errors)) {
                        console.log("#" + key + "error");

                        if (formElement != "") {
                            formElement.find("#" + key + "error").text(value);
                        }
                        else {
                            $("#" + key + "error").text(value)
                        }
                    }

                    if (data.sweeterror) {
                        var errorHTML = "<ul>";
                        for (const [key, value] of Object.entries(
                            data.errors
                        )) {
                            errorHTML += `<li><b>${ucwords(
                                key.replace("_", " ")
                            )} : </b>${value}</li>`;
                        }
                        errorHTML += "</ul>";

                        Swal.fire({
                            title: "Error",
                            html: errorHTML,
                            icon: "error",
                        });
                    }
                }
            } else if (data.success && data.route) {
                if (data.socket_trigger && socket) {
                    if (
                        typeof data.socket_trigger == "object" ||
                        typeof data.socket_trigger == "array"
                    ) {
                        data.socket_trigger.forEach((element) => {
                            console.log(element);
                            socket.emit("updatesection", {
                                page: "home",
                                layout_id: element,
                            });
                        });
                    }
                }
                window.location.href = data.route;
            }
        },
        error: function (request, status, error) {
            if (request.status == "500" || request.status == "405") {
                alert(error);
                $("#lds-roller").hide();
            }
            if (request.status == "409") {
                alert(error);
                $("#lds-roller").hide();
            }
        },
    });
    $("#lds-roller").hide();
    return response;
}


$(document).on("click", ".closeRegisterOptionsPopup", function () {
    $('body').removeAttr('style');
    $("#registrationOptions").removeClass("show");
});

$(document).on("click", ".closeRegisterSponsorshipPopup", function () {
    $('body').removeAttr('style');
    if (getSponsorshipHome) {
        $(".registrationFormContainerSponsorship").removeClass("show");
        $("#registrationOptions").removeClass("show");
    }
    else {
        $('body').css({
            'overflow': 'hidden'
        });
        $(".registrationFormContainerSponsorship").removeClass("show");
        $("#registrationOptions").addClass("show");
    }
});

$(document).on("click", ".closeRegisterPopup", function () {
    $(".registration").removeClass("show");
    $('body').css({
        'overflow': 'hidden'
    });
    $("#registrationOptions").addClass("show");
});

$(document).on("click", ".closePromocodecontainer", function (e) {
    e.preventDefault();
    $(".promo-code-popup").hide();
});

$(document).on("click", ".closePromoApply", function (e) {
    e.preventDefault();
    discountId = "";
    discountAmount = "";
    discountType = "";
    discountName = "";
    discountValue = "";
    priceCount();
});

$(document).on("click", ".get-sponsorship", function (e) {
    e.preventDefault();
    if ($(this).data('home') && $(this).data('home') == "yes") {
        getSponsorshipHome = true;
    }
    else {
        getSponsorshipHome = false;
    }
    $('body').css({
        'overflow': 'hidden'
    });
    $(".registrationOptions").removeClass("show");
    $(".registration").removeClass("show");
    $(".registrationFormContainerSponsorship").addClass("show");
});

$(document).on("click", ".register-form", function (e) {
    e.preventDefault();
    $('[name="company_type"]').val("").trigger('change');
    $(".registrationFormContainerSponsorship").removeClass("show");
    $(".registrationOptions").removeClass("show");
    $(".registration").addClass("show");
    $('body').css({
        'overflow': 'hidden'
    });
});

$(document).on("click", ".free-registration", function (e) {
    e.preventDefault();
    $('[name="company_type"] option[data-free="1"]:first').prop('selected', true);
    $('[name="company_type"]').trigger("change");
    $(".registrationFormContainerSponsorship").removeClass("show");
    $(".registrationOptions").removeClass("show");
    $(".registration").addClass("show");
    $('body').css({
        'overflow': 'hidden'
    });
});

$(document).on("click", ".student-registration", function (e) {
    e.preventDefault();
    $('[name="company_type"] option[data-student="yes"]:first').prop('selected', true);
    $('[name="company_type"]').trigger("change");
    $(".registrationFormContainerSponsorship").removeClass("show");
    $(".registrationOptions").removeClass("show");
    $(".registration").addClass("show");
    $('body').css({
        'overflow': 'hidden'
    });
});

function priceCount() {
    var SelectedCompanyType = $("select[name=company_type]").find(':selected').data("free");
    var isStudent = $("select[name=company_type]").find(':selected').data("student");
    if (isStudent == "yes") {
        eventPrice = 1180;
        eventWithoutGSTPrice = 1000;
        $(".document-section").show();
        $("#document").attr("required", "required");
    }
    else {
        eventPrice = backupEventPrice;
        eventWithoutGSTPrice = backupEventWithoutGSTPrice;
    }
    var participants = $("select[name=participants]").val();
    claimAmount = 0;
    $(".participants-count").text(
        $("select[name=participants]").val().length == 1 ?
            "0" + $("select[name=participants]").val() :
            $("select[name=participants]").val()
    );
    if (SelectedCompanyType) {
        $(".document-section").show();
        $(".price-amount").text("Free");
        $("#document").attr("required", "required");
        $("#per-person-amount").text("0");
        $(".apply-promo-code-link").hide();
        $(".promo-text").hide();
    } else {
        if (isStudent != "yes") {
            $(".document-section").hide();
            $("#document").removeAttr("required");
        }

        console.log("eventPrice", eventPrice);

        claimAmount = eventPrice * parseInt(participants);
        eventWithoutGSTPriceClaimAmount = eventWithoutGSTPrice * parseInt(participants);
        console.log("eventWithoutGSTPriceClaimAmount", eventWithoutGSTPriceClaimAmount);
        console.log("eventWithoutGSTPriceClaimAmount", eventWithoutGSTPriceClaimAmount);

        if (discountId != "") {
            if (discountType == "1") {
                discountAmount = ((claimAmount * discountValue) / 100);
                claimAmount = (claimAmount - discountAmount);
            }
            else {
                if (claimAmount < discountValue) { // 3540 < 2200
                    discountAmount = claimAmount;
                    claimAmount = claimAmount - discountAmount;
                }
                else {
                    discountAmount = discountValue;
                    claimAmount = claimAmount - discountAmount;
                }
            }
            $(".apply-promo-code-link").hide();
            $(".promo-text").show();
            // ${discountAmount}
            $("#per-person-amount").text(eventPrice * parseInt(participants) + " - " + discountAmount + " discount" + " (With 18% GST)");
            $(".promo-text").html(`Promo Code Discount <strong>${discountName}</strong><button class="closePromoApply"><img src="assets/images/icons/icon-close-red.svg?v=1.1" /></button>`);
        }
        else {
            $("#per-person-amount").text(claimAmount + " (With 18% GST)");
            $(".apply-promo-code-link").show();
            $(".promo-text").hide();
        }
        $(".price-amount").text(`₹ ${(claimAmount).toFixed(2)}`);
        $("#amount").val((claimAmount).toFixed(2));
    }
    $("#form_submit").val("");
}

function toggleSubmitButton() {
    var isValid = true;

    $("form#event-registration-form :input:not(:checkbox)").each(
        function (i, v) {
            if (!$(v).hasClass("document-section") || ($("select[name=company_type]").find(':selected').data("free")) || ($("select[name=company_type]").find(':selected').data("student") == "yes")) {
                if ($(this).prop("required") && !$(this).val()) {
                    isValid = false;
                    return false;
                }
            }
        }
    );

    $("form#event-registration-form :checkbox").each(function (i, v) {
        if ($(this).prop("required") && !$(this).prop("checked")) {
            // console.log(v);
            isValid = false;
            return false; // Break the loop if any required checkbox is unchecked
        }
    });

    if ($("#gst").val() != "" && $("#gst").val() != null) {
        const gstNumber = $('#gst').val().toUpperCase(); // Convert to uppercase for uniformity
        if (gstRegex.test(gstNumber)) {
            $("#gst").css('color', 'green');
        } else {
            isValid = false;
            $("#gst").css('color', 'red');
        }
    }

    if (!emailRegex.test($("#email").val())) {
        isValid = false;
        $("#email").css('color', 'red');
    }
    else {
        $("#email").css('color', 'black');
    }

    $("#registertion-submit").prop("disabled", !isValid);
}

function checkMultipleDetails(form) {
    var frequencyMap = {};
    $.each(form, function (index, item) {
        var name = item.name;
        frequencyMap[name] = (frequencyMap[name] || 0) + 1;
    });

    // Extract names with frequency greater than 1
    var repeatedNames = [];
    for (var name in frequencyMap) {
        if (frequencyMap.hasOwnProperty(name) && frequencyMap[name] > 1) {
            repeatedNames.push(name);
        }
    }

    return repeatedNames;
}

$(document).on(
    "change",
    "select[name=company_type],select[name=participants]",
    function () {
        priceCount();
        toggleSubmitButton();
    }
);

$("form#event-registration-form :input").on(
    "input change",
    toggleSubmitButton
);

$(document).on("click", ".apply-promo-code-link", function (e) {
    e.preventDefault();
    $(".promo-code-popup").css({
        display: "flex"
    });
});

$(document).on("submit", "#promocode_form", async function (e) {
    e.preventDefault();
    var data = await ajaxDynamicMethod(backendURL + "/api/fourm/payment/apply-promocode", $(this).attr('method'), generateFormData(this));
    if (data.success) {
        discountValue = data.data.promocode.value;
        discountType = data.data.promocode.type;
        discountName = data.data.promocode.code;
        discountId = data.data.promocode.id;
        priceCount();
        $("#promocode").val("");
        $(".promo-code-popup").hide();
    }
});

$(document).on('keypress', '.numericonly', function (e) {
    e = (e) ? e : window.event;
    var charCode = (e.which) ? e.which : e.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        e.preventDefault();
    }
    else {
        return true;
    }
});

$(document).on("submit", "#sponsor_form", async function (e) {
    e.preventDefault();

    if (!currentURL.includes("127.0.0.1") && !currentURL.includes("192.168.1") && !currentURL.includes("localhost")) {
        var recaptchaResponse = grecaptcha.getResponse();
        if (recaptchaResponse === "") {
            $('#g-recaptcha-responseerror').text('Required');
            return;
        }
        else {
            $('#g-recaptcha-responseerror').text('');
        }
    }

    var formData = new FormData();
    formData.append('first_name', $("#firstname").val());
    formData.append('last_name', $("#lastname").val());
    formData.append('job_title', $("#jobtitle").val());
    formData.append('phone_number', $("#phonenumber").val());
    formData.append('email', $("#emailaddress").val());
    formData.append('company_name', $("#sponsor_company").val());
    formData.append('company_website', $("#companywebsite").val());
    formData.append('company_type', $("#sponsor_company_type").val());
    formData.append('sponsorship_type', $("#sponsorship_type").val());
    formData.append('message', $("#sponsor_message").val());
    formData.append('event_id', '2');

    var response = await ajaxDynamicMethod(backendURL + "/api/fourm/sponsor-request", "POST", formData, $(this));
    if (response.success) {
        $(".registrationFormContainerSponsorship").removeClass("show");
        alert("Your request successfully register.");
        $("#firstname").val('');
        $("#lastname").val('');
        $("#jobtitle").val('');
        $("#phonenumber").val('');
        $("#emailaddress").val('');
        $("#sponsor_company").val('');
        $("#companywebsite").val('');
        $("#sponsor_company_type").val('');
        $("#sponsorship_type").val('');
        $("#sponsor_message").val('');
    }
    else if (response.errors.length == "0" && response.msg) {
        console.log('Error: ' + response.message);
        alert("Something Went Wrong.");
    }
});


function generateFormData(param) {
    var dataArr = $(param).serializeArray();
    var mutipleValue = checkMultipleDetails(dataArr);
    var formData = new FormData();
    $.each(dataArr, function (i, field) {
        if ($.inArray(field.name, mutipleValue) !== -1) {
        } else {
            formData.append(field.name, field.value);
        }
    });
    $.each(mutipleValue, function (index, value) {
        $.each(dataArr, function (i, field) {
            if (field.name == value) {
                formData.append(
                    field.name.replace("[]", "") + "[]",
                    field.value
                );
            }
        });
    });
    $.each(
        $(param).find('input[type="file"]:not([multiple])'),
        function (i, field) {
            formData.append(
                field.name,
                $(field)[0].files[0] != undefined ? $(field)[0].files[0] : ""
            );
        }
    );
    $.each($(param).find('input[type="file"][multiple]'), function (i, field) {
        var fileInput = $(field)[0];
        var files = fileInput.files;
        for (var i = 0; i < files.length; i++) {
            formData.append(field.name.replace("[]", "") + "[]", files[i]);
        }
        // formData.append(field.name + "[]", (($(field)[0].files[0]) != undefined) ? $(field)[0].files[0] : "");
    });

    return formData;
}

$(document).on("submit", "#event-registration-form", async function (e) {
    e.preventDefault();
    console.log($("#amount").val(), typeof $("#amount").val());

    if ($("#form_submit").val() == "Yes" || $("#amount").val() == "0") {

        if ($("#amount").val() == "0") {
            $("#discount_amount").val(discountAmount);
            $("#promo_code_id").val(discountId);
            $("#payment_id").val("Promo Apply Amount 0");
            $("#order_id").val("Promo Apply Amount 0");
        }

        var data = await ajaxDynamicMethod(backendURL + "/api/fourm/register", $(this).attr('method'), generateFormData(this));
        console.log(data);
        if (data.success) {
            window.location.href = frontendURL + "/thank-you.php?order_number=" + data.data.order_id.order_id;
        }
    }
    else {
        var SelectedCompanyType = $("select[name=company_type]").find(':selected').data("free");
        if (SelectedCompanyType) {
            $("#amount").val("");
            $("#discount_amount").val("");
            $("#promo_code_id").val("");
            $("#form_submit").val("Yes");
            $("#event-registration-form").trigger("submit");
        }
        else {
            $("#amount").val(claimAmount);
            $("#discount_amount").val(discountAmount);
            $("#promo_code_id").val(discountId);
            var formData = new FormData();
            formData.append("amount", claimAmount);
            var data = await ajaxDynamicMethod(backendURL + "/api/fourm/payment/generate-order", "POST", formData);
            if (data.success) {
                var options = {
                    "key": data.data.details.RazorpayId,
                    "amount": data.data.details.amount,
                    "currency": "INR",
                    "method": {
                        "netbanking": "1",
                        "card": "1",
                        "upi": "1",
                        "wallet": "0",
                        "emi": "0",
                        "payLater": "0",
                    },
                    "name": "DHN",
                    "description": "DHN FORUM DELHI",
                    "image": "https://www.digitalhealthnews.com/assets/user/images/dhn-Logo.png",
                    "order_id": data.data.details.order_id,
                    "handler": function (response) {
                        $("#payment_id").val(response.razorpay_payment_id);
                        $("#order_id").val(response.razorpay_order_id);
                        $("#signature").val(response.razorpay_signature);
                        $("#form_submit").val("Yes");
                        $("#status").val("success");
                        $("#event-registration-form").trigger("submit");
                    },
                    "prefill": {
                        "name": $("#name").val(),
                        "email": $("#email").val(),
                        "contact": $("#phone").val(),
                    },
                    "notes": {
                        "address": "",
                    },
                    "theme": {
                        "color": "#ee801d"
                    }
                };
                var rzp1 = new Razorpay(options);
                rzp1.on('payment.failed', function (response) {
                    window.location.href = frontendURL + "/payment-fail.php";
                });
                rzp1.open();
            }
        }
    }
});

$(document).on("change", "#document", function () {
    const file = this.files[0];
    const maxSize = 4 * 1024 * 1024; // 4 MB in bytes

    if (file) {
        if (file.size > maxSize) {
            alert("File size must be 4 MB or smaller.");
            $(this).val(''); // Clear the file input
        }
    }
});

$(document).on('click', '#mainNav .navItems .navItem .navLink', function (e) {
    e.preventDefault();

    var targetID = $(this).attr('href');
    var targetElement = $(targetID);

    if (targetElement.length) {
        $('html, body').animate({
            scrollTop: (targetElement.offset().top - 40)
        }, 800); // 800ms for smooth scrolling
    }

    $('.mobileMenuToggle').removeClass('is-open');
});

$(document).on('click', '#mainNavLanding .navItems .navItem .navLink', function (e) {
    e.preventDefault();

    var targetID = $(this).attr('href');
    var targetElement = $(targetID);
    console.log(targetElement);


    if (targetElement.length) {
        console.log(targetID);

        if (targetID == "#aboutCityMeetup") {
            $('html, body').animate({
                scrollTop: 0
            }, 800); // 800ms for smooth scrolling
        }
        else {

            $('html, body').animate({
                scrollTop: (targetElement.offset().top - 70)
            }, 800); // 800ms for smooth scrolling
        }
    }
    $('.mobileMenuToggle').removeClass('active');
});
$(document).on('click', '#samePageLink', function (e) {
    e.preventDefault();

    var targetID = $(this).attr('href');
    var targetElement = $(targetID);

    if (targetElement.length) {
        $('html, body').animate({
            scrollTop: (targetElement.offset().top - 70)
        }, 800); // 800ms for smooth scrolling
    }
});

function showNextSlide() {
    const currentSlide = slides[currentIndex];
    currentIndex = (currentIndex + 1) % slides.length;
    const nextSlide = slides[currentIndex];

    // Animate current slide out to the left
    gsap.to(currentSlide, { x: "-100%", duration: 1, onComplete: () => currentSlide.classList.remove("active") });

    // Position next slide off-screen to the right
    gsap.set(nextSlide, { x: "100%" });
    nextSlide.classList.add("active");

    // Animate next slide in from the right
    gsap.to(nextSlide, { x: "0%", duration: 1 });
}

// Start the slider
function startSlider() {
    interval = setInterval(showNextSlide, 5000);
}

// Stop the slider
function stopSlider() {
    clearInterval(interval);
}

if (slider) {
    // Start slider on page load
    startSlider();

    // Pause on hover
    slider.addEventListener("mouseenter", stopSlider);
    slider.addEventListener("mouseleave", startSlider);
}


$(document).on("click", ".gallery-card", function (e) {
    e.preventDefault();
    $(".big-gallery-img-url").attr("src", $(this).find("img").attr("src"));
    $(".big-gallery-img").css('display', 'flex');
    $("body").addClass("rtbGalleryLightboxOpen");
});

$(document).on("click", ".closeRegisterPopupgallery", function (e) {
    $(".big-gallery-img").css('display', 'none');
    $("body").removeClass("rtbGalleryLightboxOpen");
});

$(document).on("click", ".big-gallery-img", function (e) {
    if ($(e.target).is(".big-gallery-img")) {
        $(".big-gallery-img").css('display', 'none');
        $("body").removeClass("rtbGalleryLightboxOpen");
    }
});

function rtbNavigateGallery(direction) {
    var currentImgPath = $(".big-gallery-img").find("img").attr("src");
    var currentGalleryImg = $('img[src="' + currentImgPath + '"].gallery-img');
    var targetCard = null;

    if (direction === "prev") {
        if (currentGalleryImg.closest(".gallery-card").prev().length) {
            targetCard = currentGalleryImg.closest(".gallery-card").prev();
        } else {
            targetCard = $(".gallery-column .gallery-card").last();
        }
    } else if (direction === "next") {
        if (currentGalleryImg.closest(".gallery-card").next().length) {
            targetCard = currentGalleryImg.closest(".gallery-card").next();
        } else {
            targetCard = $(".gallery-column .gallery-card").first();
        }
    }

    if (targetCard && targetCard.length) {
        $(".big-gallery-img-url").attr("src", targetCard.find("img").attr("src"));
    }
}

$(document).on("click", ".previous .btn", function (e) {
    e.stopPropagation();
    rtbNavigateGallery("prev");
});

$(document).on("click", ".next .btn", function (e) {
    e.stopPropagation();
    rtbNavigateGallery("next");
});

$(document).on("keydown", function (e) {
    if (!$(".big-gallery-img").is(":visible")) {
        return;
    }

    if (e.key === "Escape") {
        $(".big-gallery-img").css('display', 'none');
        $("body").removeClass("rtbGalleryLightboxOpen");
    } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        rtbNavigateGallery("prev");
    } else if (e.key === "ArrowRight") {
        e.preventDefault();
        rtbNavigateGallery("next");
    }
});


document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.faqItem');

    faqItems.forEach(item => {
        const question = item.querySelector('.faqQuestion');
        const answer = item.querySelector('.faqAnswer');
        const plusIcon = item.querySelector('.plusIcon');
        const minusIcon = item.querySelector('.minusIcon');

        question.addEventListener('click', () => {
            const isActive = item.classList.contains('active');

            // Close all other items
            faqItems.forEach(otherItem => {
                if (otherItem !== item) {
                    otherItem.classList.remove('active');
                    otherItem.querySelector('.faqAnswer').classList.remove('active');
                    otherItem.querySelector('.plusIcon').style.display = 'block';
                    otherItem.querySelector('.minusIcon').style.display = 'none';
                }
            });

            // Toggle current item
            if (isActive) {
                item.classList.remove('active');
                answer.classList.remove('active');
                plusIcon.style.display = 'block';
                minusIcon.style.display = 'none';
            } else {
                item.classList.add('active');
                answer.classList.add('active');
                plusIcon.style.display = 'none';
                minusIcon.style.display = 'block';
            }
        });
    });
});

function openRegistrationPopup() {
    document.getElementById('registrationPopup').classList.add('active');
    // document.body.style.overflow = 'hidden';
}

function closeRegistrationPopup() {
    document.getElementById('registrationPopup').classList.remove('active');
    // document.body.style.overflow = 'auto';
}

// Close popup when clicking outside
document.getElementById('registrationPopup').addEventListener('click', function (e) {
    if (e.target === this) {
        closeRegistrationPopup();
    }
});

// Close popup with Escape key
document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
        closeRegistrationPopup();
    }
});

// Open Thank You Popup
function openThankYouPopup(registrationData) {
    const popup = document.getElementById('thankYouPopup');
    const regNumberEl = document.getElementById('thankYouRegNumber');

    if (regNumberEl && registrationData.registration_number) {
        regNumberEl.textContent = registrationData.registration_number;
    }

    popup.classList.add('active');
    // document.body.style.overflow = 'hidden';
}

// Close Thank You Popup
function closeThankYouPopup() {
    const popup = document.getElementById('thankYouPopup');
    popup.classList.remove('active');
    // document.body.style.overflow = 'auto';
}

// Updated handleSubmit function
async function handleSubmit(event) {
    event.preventDefault();

    const form = event.target;
    const submitBtn = form.querySelector('.submitBtn');
    const originalBtnText = submitBtn.textContent;

    // Disable submit button
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting...';

    // Get form data
    const formData = new FormData(form);
    const data = {
        fullName: formData.get('fullName'),
        email: formData.get('email'),
        mobile: formData.get('mobile'),
        designation: formData.get('designation'),
        organization: formData.get('organization'),
        city: formData.get('city'),
        industry: formData.get('industry'),
        registrationType: formData.get('registrationType'),
        updates: formData.get('updates') === 'on',
        accuracy: formData.get('accuracy') === 'on'
    };

    try {
        const response = await fetch('https://www.digitalhealthnews.com/api/city-meet-up/register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data)
        });

        const result = await response.json();

        if (result.success) {
            // Close registration popup
            closeRegistrationPopup();

            // Reset form
            form.reset();

            // Show thank you popup with registration data
            setTimeout(() => {
                openThankYouPopup(result.data);
            }, 300);

        } else {
            // Show error message
            alert(result.message || 'Registration failed. Please try again.');
        }

    } catch (error) {
        console.error('Registration error:', error);
        alert('An error occurred during registration. Please try again later.');
    } finally {
        // Re-enable submit button
        submitBtn.disabled = false;
        submitBtn.textContent = originalBtnText;
    }
}

// Close popup when clicking outside
document.addEventListener('click', function (event) {
    const thankYouPopup = document.getElementById('thankYouPopup');
    if (event.target === thankYouPopup) {
        closeThankYouPopup();
    }
});

// Close popup with Escape key
document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
        const thankYouPopup = document.getElementById('thankYouPopup');
        if (thankYouPopup.classList.contains('active')) {
            closeThankYouPopup();
        }
    }
});

document.querySelector('.mobileMenuToggle')
    .addEventListener('click', function () {
        this.classList.toggle('is-open');
    });
